import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import Form from './Form';
import queryString from '../../utils/query-string';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import { requestDataIfNeeded } from '../../workspace/duck';

class Settings extends React.Component {
  constructor(props) {
    super(props);

    const { hostname } = window.location;
    const subdomain = hostname.split('.')[0];

    this.state = {
      isLoading: true,
      workspaceSlug: subdomain,
      error: null,
    };
  }

  componentDidMount() {
    this.getData(this.state.workspaceSlug);
  }

  getData = (workspaceSlug) => {
    this.setState({ isLoading: true });

    // Quite ugly, bu the fastest way to get the full admin details
    // for this specific workspace. Sorry.
    // Refactor it some sunny day, when there is enough time for that!
    API.get(`workspaces/${workspaceSlug}/full`)
      .then((workspaceFullData) =>
        this.setState({ workspaceFullData, error: null })
      )
      .catch((err) => this.setState({ error: JSON.stringify(err) }))
      .finally(() => this.setState({ isLoading: false }));
  };

  handleSubmit = (formValues, dispatch, { workspaceId }) => {
    const { onSuccess } = this.props;

    return API.post(`workspaces/${workspaceId}`, formValues)
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  handleWorkspaceSlugChange = (e) => {
    this.setState({ workspaceSlug: e.target.value });

    // Refresh data
    this.getData(e.target.value);
  };

  render() {
    const { t, isSuperAdmin, isDueDatePassed } = this.props;
    const { isLoading, workspaceFullData, workspaceSlug, error } = this.state;
    const urlParams = queryString.parse(this.props.location.search);

    const shouldStartWithBillingTab =
      urlParams.tab === 'billing' || isDueDatePassed;

    return (
      <div className="u-margin-bottom">
        {isSuperAdmin && (
          <React.Fragment>
            <input
              className="c-input u-margin-bottom"
              value={workspaceSlug}
              onChange={this.handleWorkspaceSlugChange}
            />
          </React.Fragment>
        )}
        {isLoading ? (
          t('general.loading')
        ) : error ? (
          error
        ) : (
          <Form
            okButtonText={t('general.saveChanges')}
            onSubmit={this.handleSubmit}
            workspaceId={workspaceFullData._id}
            initialValues={workspaceFullData}
            status={workspaceFullData.status}
            userSlots={workspaceFullData.userSlots}
            defaultPrimaryTab={
              shouldStartWithBillingTab
                ? 'vertical-tab-billing'
                : 'vertical-tab-one'
            }
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = { requestDataIfNeeded };
const mapStateToProps = ({ user, workspace }) => ({
  isSuperAdmin:
    user &&
    user.data &&
    user.data.roles &&
    user.data.roles.includes('SUPER_ADMIN'),
  isDueDatePassed:
    workspace.data &&
    workspace.data.status &&
    workspace.data.status.isDueDatePassed,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(withRouter(Settings)));



// WEBPACK FOOTER //
// ./src/admin/settings/index.js